interface LocationLinkProps {
  lat: string | null | undefined;
  lng: string | null | undefined;
}

const LocationLink = ({ lat, lng }: LocationLinkProps) => {
  if (!lat || !lng) return null;
  if (parseFloat(lat) === 0 && parseFloat(lng) === 0) return null;

  const url = `https://www.google.com/maps?q=${lat},${lng}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="text-xs text-blue-600 underline hover:text-blue-800"
    >
      {lat}, {lng}
    </a>
  );
};

export default LocationLink;
